import type { RefObject } from 'react';

export type GetSideElementPaddingProps = {
  sideElementWidth: number;
  padding: number;
  inputRef: RefObject<HTMLInputElement | null>;
  sideElementRef: RefObject<HTMLDivElement | null>;
  hasRenderer: boolean;
  paddingOffset?: number;
};

export const getSideElementPadding = ({
  sideElementWidth,
  padding,
  inputRef,
  sideElementRef,
  hasRenderer,
  paddingOffset = 0,
}: GetSideElementPaddingProps): number => {
  if (!inputRef?.current) return 0;

  if (!hasRenderer) {
    return padding + paddingOffset;
  }

  const actualElementWidth =
    sideElementWidth > 0
      ? sideElementWidth
      : sideElementRef?.current?.getBoundingClientRect()?.width || 0;

  return padding + Math.max(0, actualElementWidth) + paddingOffset;
};
